import ReactGA from 'react-ga4';
import { measurement_id } from './consts';

export enum EventCategory {
  CLICK = 'Click',
  VIEW = 'View',
}

export class EventStore {
  private static instance: EventStore;

  static get = () => {
    if (!EventStore.instance) {
      EventStore.instance = new EventStore();
    }

    return EventStore.instance;
  };

  initialize = () => {
    if (process.env.REACT_APP_DATA_ENV !== 'local')
      ReactGA.initialize(measurement_id);
  };

  sendEvent = (event: string, category: EventCategory) => {
    if (process.env.REACT_APP_DATA_ENV === 'local') return;
    ReactGA.event({
      category,
      action: event,
    });
  };
}
